<template>
  <div>
    <Head title="Channels" />
    <div class="flex items-center mb-8">
      <h1 class="text-3xl font-bold">Channels</h1>
      <span class="text-xs mx-2 rounded-full p-2 bg-gray-200"> {{ channels.total }}</span>
    </div>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Deleted:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null">Exclude Deleted</option>
          <option value="with">Include Deleted</option>
          <option value="only">Only Deleted</option>
        </select>
      </search-filter>
      <div class="flex gap-4">
        <a href="/channels/export" target="_blank" class="border border-gray-600 text-gray-600 flex items-center px-4 hover:bg-gray-600 hover:text-white" download>Export</a>
        <Link class="btn-blue" href="/channels/create">
          <span>Create</span>
          <span class="hidden md:inline">&nbsp;Channel</span>
        </Link>
      </div>
    </div>
    <div class="bg-white  shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Part number</th>
            <th class="pb-4 pt-6 px-6">System</th>
            <th class="pb-4 pt-6 px-6">Edge</th>
            <th class="pb-4 pt-6 px-6">Width</th>
            <th class="pb-4 pt-6 px-6">Length</th>
            <th class="pb-4 pt-6 px-6">Depth</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="channel in channels.data" :key="channel.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/channels/${channel.id}/edit`" tabindex="-1">
                {{ channel.part_number }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-blue-500" :href="`/channels/${channel.id}/edit`">
                {{ channel.system }}
                <icon v-if="channel.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-blue-500" :href="`/channels/${channel.id}/edit`">
                {{ channel.edge }}
                <icon v-if="channel.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-blue-500" :href="`/channels/${channel.id}/edit`">
                {{ channel.width }}
                <icon v-if="channel.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/channels/${channel.id}/edit`" tabindex="-1">
                {{ channel.length }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/channels/${channel.id}/edit`" tabindex="-1">
                {{ channel.depth }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/channels/${channel.id}/edit`" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="channels.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No channels found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="channels.links" :total="channels.total" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    channels: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/channels', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
